export default __webpack_public_path__ + "static/media/icon_hope_24_Regular.f8755593.svg";